import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';

/**
 * Kundens benämning på vänmedlemskap. Kunden kan döpa om funktionen i
 * medlemsregisterinställningarna, och då ska alla vyer följa med.
 */
export const useExtraMembershipLabel = () => {
  const { t } = useTranslation(['member']);
  const { currentUser } = useGlobals();

  return getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.NewFriendLabel, '') || t('member:extraMembership.header');
};

export default useExtraMembershipLabel;
